import { useCheckTargetAccumulatorByTradeCapture } from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';

const DeleteIcon = ({ legId }: { legId: string }) => {
  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handleDelete = () => {
    return checkTargetAccumulatorWithTradeCapture({
      schedule: { [legId]: null },
    });
  };
  return (
    <button type="button" className="btn btn-sm btn-link btn-icon mx-1" data-e2e="delete" onClick={handleDelete}>
      <i className="icon icon-sm">delete_outline</i>
    </button>
  );
};

export default DeleteIcon;
